module.exports = __webpack_public_path__ + "img/3d_驱动主机.ae88194a.png";